import { useAuth0 } from '@auth0/auth0-react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import { useDisplayCurrency } from 'src/contexts/DisplayCurrencyContext';
import {
  DisplayCurrency,
  supportedDisplayCurrencies
} from 'src/utils/currencyFormatting';

const selectorLabelId = 'display-currency-selector-label';

export const DisplayCurrencySelector = () => {
  const { isAuthenticated } = useAuth0();
  const { displayCurrency, isLoading, isSaving, updateDisplayCurrency } = useDisplayCurrency();

  if (!isAuthenticated) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    void updateDisplayCurrency(event.target.value as DisplayCurrency).catch((error) => {
      console.error('Failed to update display currency selection:', error);
    });
  };

  return (
    <FormControl
      size="small"
      sx={{ minWidth: { xs: 84, sm: 120 }, mr: { xs: 1, sm: 2 } }}
    >
      <InputLabel id={selectorLabelId}>Display</InputLabel>
      <Select
        labelId={selectorLabelId}
        value={displayCurrency}
        label="Display"
        disabled={isLoading || isSaving}
        onChange={handleChange}
      >
        {supportedDisplayCurrencies.map((currency) => (
          <MenuItem key={currency} value={currency}>
            {currency}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};